import React from 'react'
import {
  IMembersSelectorGroup,
  IMembersSelectorUser,
  MemberTypeEnum
} from '../MembersSelectors.types'
import { UserRow } from './UserRow'
import { GroupRow } from './GroupRow'
import { RemoveMemberRow } from './RemoveMemberRow'
import { useMembersSelectorContext } from '../MembersSelectorContext'
import { observer } from 'mobx-react-lite'

type SelectedMemberRowsProps = {}

function isUser(arg: any): arg is IMembersSelectorUser {
  return arg.type === MemberTypeEnum.USER
}

export const SelectedMemberRows: React.FC<SelectedMemberRowsProps> = observer(
  () => {
    const {
      removeUser,
      removeGroup,
      selectedMembers: { users: selectedUsers, groups: selectedGroups }
    } = useMembersSelectorContext()
    const entities = React.useMemo(() => {
      const users = selectedUsers.map((user) => ({
        ...user,
        type: MemberTypeEnum.USER
      }))
      const groups = selectedGroups.map((group) => ({
        ...group,
        type: MemberTypeEnum.GROUP
      }))

      const entities = (
        users as Array<IMembersSelectorGroup | IMembersSelectorUser>
      ).concat(groups)

      return entities.sort((a, b) =>
        a.added_at && b.added_at
          ? b.added_at.getTime() - a.added_at.getTime()
          : 0
      )
    }, [selectedUsers, selectedGroups])

    return (
      <div className="MembersSelector__selected">
        <div className="MembersSelector__content">
          {entities.length > 0 && (
            <div className="MembersSelector__members">
              {entities.map((member) => {
                return isUser(member) ? (
                  <RemoveMemberRow
                    removeMember={removeUser}
                    member={member}
                    key={member.id}
                  >
                    <UserRow user={member} action={'remove'} />
                  </RemoveMemberRow>
                ) : (
                  <RemoveMemberRow
                    removeMember={removeGroup}
                    member={member}
                    key={member.id}
                  >
                    <GroupRow group={member} action={'remove'} />
                  </RemoveMemberRow>
                )
              })}
            </div>
          )}
        </div>
      </div>
    )
  }
)
